import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Comparateur from "@/pages/Comparateur";
import Baskets from "@/pages/Baskets";
import Alerts from "@/pages/Alerts";
import Admin from "@/pages/Admin";
import SharedBasket from "@/pages/SharedBasket";
import Premium from "@/pages/Premium";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Subscription from "@/pages/Subscription";
import Legal from "@/pages/Legal";
import { SplashScreen } from "@/components/SplashScreen";
import { Loader2 } from "lucide-react";

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="h-6 w-6 animate-spin text-primary" />
    </div>
  );
}

function Protected({ children, admin }) {
  const { user, checked } = useAuth();
  if (!checked) return <Loading />;
  if (!user) return <Navigate to="/connexion" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/comparateur" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/connexion" element={<Login />} />
      <Route path="/inscription" element={<Register />} />
      <Route path="/comparateur" element={<Comparateur />} />
      <Route path="/panier/:token" element={<SharedBasket />} />
      <Route path="/premium" element={<Premium />} />
      <Route path="/abonnement" element={<Protected><Subscription /></Protected>} />
      <Route path="/mentions-legales" element={<Legal />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/paniers" element={<Protected><Baskets /></Protected>} />
      <Route path="/alertes" element={<Protected><Alerts /></Protected>} />
      <Route path="/admin" element={<Protected admin><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SplashScreen />
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
